import { render, staticRenderFns } from "./SectionDevelopment.vue?vue&type=template&id=bd8b3414&scoped=true"
import script from "./SectionDevelopment.vue?vue&type=script&lang=ts"
export * from "./SectionDevelopment.vue?vue&type=script&lang=ts"
import style0 from "./SectionDevelopment.vue?vue&type=style&index=0&id=bd8b3414&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8b3414",
  null
  
)

export default component.exports